'use client';

import { useState } from 'react';
import { useTranslations } from 'next-intl';
import { Gift } from 'lucide-react';
import { useAuthStore } from '@/hooks/use-auth';
import { GiftVoucherDialog } from './gift-voucher-dialog';

type Props = {
  courseId: string;
  courseName: string;
  priceCents: number;
};

export function GiftCourseButton({ courseId, courseName, priceCents }: Props) {
  const [open, setOpen] = useState(false);
  const user = useAuthStore((s) => s.user);
  const t = useTranslations('giftVoucher');

  // Only show for authenticated parents
  if (!user || user.role !== 'parent') return null;

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="w-full min-h-11 flex items-center justify-center gap-2 py-2.5 text-sm font-semibold text-[var(--eifo-primary)] border-2 border-[var(--eifo-primary)] rounded-lg hover:bg-[#f1f5f9] transition-colors"
      >
        <Gift className="h-4 w-4" />
        {t('giftThisCourse')}
      </button>
      <GiftVoucherDialog
        courseId={courseId}
        courseName={courseName}
        priceCents={priceCents}
        open={open}
        onClose={() => setOpen(false)}
      />
    </>
  );
}
